"use client"
import React from 'react';
import {useController} from "react-hook-form"
import {cn} from "@root/server/client/esweb/lib/utils.ts"
import {Field, FieldError, FieldLabel} from "@root/server/client/esweb/components/ui/field.tsx";
import {Lens} from "@hookform/lenses";


interface ObjectKeyCheckboxOption {
    key: string,
    label: string;
}


export function RhfObjectKeyCheckboxGroup(params: {
    lens: Lens<Record<string, boolean | undefined>>
    className?: string;
    options: Readonly<ObjectKeyCheckboxOption[]>,
    label: string;
}) {

    const {
        label,
        options,
        className,
        lens
    } = params;


    const {
        fieldState
    } = useController(lens.interop());

    return (
        <Field>
            <FieldLabel>{label}</FieldLabel>
            <div className="space-y-2">
                <div className={cn("flex flex-wrap gap-2", className)}>
                    {options.map((option) => {
                        return <Pill {...{option, lens: lens.focus(option.key)}}/>
                    })}
                </div>
            </div>
            {fieldState.invalid && (
                <FieldError errors={[fieldState.error]}/>
            )}
        </Field>

    )
}


const Pill = function (params: {option: ObjectKeyCheckboxOption, lens: Lens<boolean | undefined>}) {
    const {
        option: {label, key},
        lens
    } = params;

    const {
        field,
        fieldState
    } = useController({...lens.interop()});

    const handleToggle = () => {
        field.onChange(!field.value);
    }

    return <>
        <button
            key={key}
            type="button"
            onClick={handleToggle}
            className={cn(
                "px-4 py-2 rounded-full text-sm font-medium transition-all duration-200",
                "border-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                field.value
                    ? "bg-primary text-primary-foreground border-primary shadow-sm"
                    : "bg-background text-foreground border-border hover:bg-accent hover:text-accent-foreground",
            )}
        >
            {label}
        </button>
        {fieldState.invalid && (
            <FieldError errors={[fieldState.error]}/>
        )}
    </>

}